import { render } from "./ProBookDialog.vue?vue&type=template&id=96c631e2&scoped=true"
import script from "./ProBookDialog.vue?vue&type=script&lang=js"
export * from "./ProBookDialog.vue?vue&type=script&lang=js"

import "./ProBookDialog.vue?vue&type=style&index=0&id=96c631e2&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c631e2"]])

export default __exports__